



































import Vue from 'vue';
import { FacilityStatusEnum } from '@/enums/facilityStatusEnum'
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import { globalObject } from '@/utils/proxyDataUtil'

export default Vue.component('facility-status', {
  name: 'FacilityStatus',
  props: {
    'facility-id': {
    },
  },
  data () {
    return {
      FacilityStatusEnum: FacilityStatusEnum,
      loadingFacilityStatus: false,
      facilityStatus: 0,
      facilityName: '',
      showDropdown: false,
      facility: null
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  mounted: function () {
    this.getFacilityStatus();
    try {
      this.facilityName = globalObject.variable1.name
      this.facilityStatus = globalObject.variable1.statusId
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown;
    },
    getFacilityStatus () {
      let self = this as any;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingFacilityStatus = true;
      }, 3000);
      HTTP.get('/api/facilities/' + (this as any).facilityId + '/status')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingFacilityStatus = false;
        if (!response.data || !response.data.data || !response.data.data.statusId) {
          throw new Error("Error retrieving facility's status.");
        }
        self.facilityStatus = response.data.data.statusId;
        self.facilityName = response.data.data.name;
        self.facility = response.data.data;
      })
      .catch(function (err) {
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingFacilityStatus = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching this facility\'s status.'
        });
      })
    },
    updateStatus (statusId: any) {
      if (this.facility == null) { throw new Error("Unable to update provide."); }
      setTimeout(() => { this.showDropdown = false; }, 0);
      let self = this as any;
      let oldStatus = this.facilityStatus; // this.facilityStatus;
      self.facilityStatus = statusId;
      HTTP.put('/api/facilities/' + (this as any).facilityId + '/status', {"newFacilityStatusId": statusId})
      .then(function (response) {
        if (!response.data.success) {
          throw new Error("Error updating Facility's Status.");
        } else {
          if (response.data.sentEmail) {
            self.$notify({
              group: 'main',
              type: 'success',
              title: 'Success Activated Facility',
              text: response.data.message,
            });
          }
        }
      })
      .catch(function (err) {
        console.log(err);
        self.facilityStatus = oldStatus;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating Status',
          text: 'Please try updating this facility\'s status again.'
        });
      })
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/facility/facilityComponents/FacilityStatus.vue